import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {ImageAttachmentsDialogStateData} from "../types/ImageAttachmentsDialogStateData";

export const useImageAttachmentsDialog = () => useDialogContext<ImageAttachmentsDialogStateData>('image-attachments');
